import { useCallback, useEffect, useState } from "react";
import { api, apiError } from "@/lib/api";
import { PageHeader } from "@/components/StatCard";
import { Button } from "@/components/ui/button";
import { Skeleton } from "@/components/ui/skeleton";
import { toast } from "sonner";
import { X, EyeOff, Trash2 } from "lucide-react";
import { Empty, dt } from "./_shared";

export default function Reports() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [busy, setBusy] = useState(null);

  const load = useCallback(async () => {
    setLoading(true);
    try { const { data } = await api.get("/admin/reports?status=pending"); setRows(Array.isArray(data) ? data : []); }
    catch (err) { toast.error(apiError(err)); } finally { setLoading(false); }
  }, []);
  useEffect(() => { load(); }, [load]);

  const resolve = async (r, action) => {
    setBusy(r.id);
    try { await api.post(`/admin/reports/${r.id}/resolve?action=${action}`); await load(); }
    catch (err) { toast.error(apiError(err)); } finally { setBusy(null); }
  };

  return (
    <div className="space-y-4">
      <PageHeader eyebrow="Admin" title="Meldungen" subtitle="Gemeldete Inhalte moderieren." />
      {loading ? <Skeleton className="h-64 rounded-2xl" /> : rows.length === 0 ? <Empty text="Keine offenen Meldungen." /> : (
        <div className="space-y-2">
          {rows.map((r) => (
            <div key={r.id} data-testid={`admin-report-${r.id}`} className="rounded-2xl border border-border bg-card p-4">
              <p className="text-xs text-muted-foreground">{dt(r.created_at)} · {r.reason || "—"}</p>
              {r.post && <p className="mt-1 line-clamp-2 text-sm text-foreground">{r.post.title || r.post.body || "(Beitrag)"}</p>}
              <div className="mt-3 flex flex-wrap gap-1.5">
                <Button size="sm" variant="outline" className="gap-1.5 rounded-full" disabled={busy === r.id} onClick={() => resolve(r, "dismiss")} data-testid={`admin-report-dismiss-${r.id}`}><X className="h-4 w-4" /> Verwerfen</Button>
                <Button size="sm" variant="outline" className="gap-1.5 rounded-full text-amber-600" disabled={busy === r.id} onClick={() => resolve(r, "hide")} data-testid={`admin-report-hide-${r.id}`}><EyeOff className="h-4 w-4" /> Verbergen</Button>
                <Button size="sm" variant="outline" className="gap-1.5 rounded-full text-rose-600" disabled={busy === r.id} onClick={() => resolve(r, "delete")} data-testid={`admin-report-delete-${r.id}`}><Trash2 className="h-4 w-4" /> Löschen</Button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
